import { Airport } from "../../../shared/bootstrap/bootstrap.model";

export function sameName(a: string | null | undefined, b: string | null | undefined): boolean {
    return !!a?.trim() && a.trim().toUpperCase() === b?.trim().toUpperCase();
}

/** The place of an airport as the app writes it: `CITY-NAME-CODE`, upper case, without what is missing or repeated. */
export function displayNameOf(airport: Airport): string {
    const code = (airport.code ?? "").trim();
    const city = (airport.city ?? "").trim();
    const name = (airport.name ?? "").trim();
    if (!code) return (city && city === name ? city : city || name).toUpperCase();
    let suffix = city;
    if (!(city && city.toUpperCase() === name.toUpperCase()) && name) suffix = suffix ? `${suffix}-${name}` : name;
    return (suffix ? `${suffix}-${code}` : code).toUpperCase();
}

/** Each hook and hoist by its serial and name, or whichever of the two the logbook has. */
export function accessoryLabel(accessory: { serial: string | null; name: string | null }): string {
    return [accessory.serial, accessory.name].filter((part) => !!part?.trim()).join(" · ");
}

/** A day the pilot logged, `YYYY-MM-DD`, as a local date: never through UTC, which would move it to another day. */
export function dateOf(day: string | null): Date | null {
    if (!day) return null;
    const [year, month, date] = day.slice(0, 10).split("-").map(Number);
    return new Date(year, month - 1, date);
}
